  <!--Header para mobile-->
  <header
    class="block sm:hidden w-full bg-[#1d1445] flex items-center justify-between px-5 py-5"
  >
    <button class="px-2" type="button" (click)="goBack()">
      <i class="text-white text-2xl md:text-3xl pi pi-arrow-left"></i>
    </button>

    <!-- Logo -->
    <div class="flex-1 flex justify-center">
      <div class="svgLogo" [innerHTML]="teuLogo"></div>
    </div>

    <!-- Espaciador para balancear -->
    <div class="w-7 h-7"></div>
  </header>